import React, { useState, useEffect } from "react";
import {
  Grid,
  CircularProgress,
  Typography,
  Button,
  Tabs,
  Tab,
  TextField,
  Fade,
} from "@material-ui/core";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../../context/firebase";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { withRouter, useHistory } from "react-router-dom";
// styles
import useStyles from "./styles";

// logo
import ABlogo from "../../images/ABLogo.svg";

// context
import { useUserDispatch } from "../../context/UserContext";
import { toast } from "react-toastify";
import StudentRegister from "./StudentRegister"
import "react-toastify/dist/ReactToastify.css";

//firebase
import "firebase/app";
import { UserAuth } from "../../context/AuthContext";
// import { AutoRotatingCarousel, Slide } from "material-auto-rotating-carousel";

// =================================
// const AutoRotatingCarouselModal = ({ handleOpen, setHandleOpen }) => {
//     const [list, setList] = useState([]);

//     var store = [];

//     const fetchList = async () => {
//       const querySnapshot = await getDocs(
//         collection(
//           db,
//           "topperReaction",
//         )
//       );
//       querySnapshot.forEach((doc) => {
//         store.push({
//           name: doc.data().name,
//           image: doc.data().image,
//           desc: doc.data().reaction,
//         });
//       });
//       setList(store);
//     };

//     useEffect(() => {
//       fetchList();
//     },[]);

//   return (
//     <div>
//       {/* <Button onClick={() => setHandleOpen({ open: true })}>Open carousel</Button> */}
//       <AutoRotatingCarousel
//         label="AB Physics Speaks"
//         open={handleOpen.open}
//         onClose={() => setHandleOpen({ open: false })}
//         onStart={() => setHandleOpen({ open: false })}
//         autoplay={true}
//         style={{ position: "absolute" }}
//       >
//         {list.map((value) => (
//           <Slide
//             media={<img src={value.image} alt="toppers" style={{width: "100%", borderRadius: "0 0 30px 30px"}}/>}
//             mediaBackgroundStyle={{
//               backgroundImage:
//                 "linear-gradient(90deg, #0071bc 13.68%, #1b1464 124.95%)",
//             }}
//             style={{
//               backgroundImage:
//                 "linear-gradient(90deg, #0071bc 13.68%, #1b1464 124.95%)",
//             }}
//             title={value.name}
//             subtitle={value.desc}
//           />
//         ))}
//       </AutoRotatingCarousel>
//     </div>
//   );
// };
// ==================================

function StudentLogin(props) {
  var classes = useStyles();
  var userList = [];
  // global
  var userDispatch = useUserDispatch();

  // local
  var [isLoading, setIsLoading] = useState(false);
  var [activeTabId, setActiveTabId] = useState(0);
  var [nameValue, setNameValue] = useState("");
  var [loginValue, setLoginValue] = useState("");

  var [passwordValue, setPasswordValue] = useState("");
  var [error, setError] = useState("");
  // const [user, loading] = useAuthState(auth);

  const navigate = useHistory();

  const [handleOpen, setHandleOpen] = useState({ open: false });
  const handleClick = () => {
    setHandleOpen({ open: true });
  };

  const { createUser, signIn } = UserAuth();
  const showToast = () => {
    toast.success("✅ Welcome Student!!", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  const handleSignUp = async (e) => {
    e.preventDefault(); // prevent page reload
    setIsLoading(true);
    setError("");
    try {
      await createUser(userDispatch, loginValue, passwordValue);
      navigate.push("/login");
    } catch (e) {
      setError(e.message);
    }
    setIsLoading(false);
  };
  const redirectToAdmin = () => {
    toast.info("⚠️ Only Admins Please!!", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    navigate.push("/adminlogin");
  };
  const testimonials = () => {
    try {
      navigate.push("/testimonials");
    } catch (err) {
      alert(err.message);
    }
  };
  const check = async (loginValue) => {
    const data = await getDocs(collection(db, "users"));
    data.docs.forEach((item) => {
      userList.push(
        item._document.data.value.mapValue.fields.email.stringValue
      );
    });
    console.log(userList.includes(loginValue));
    return userList.includes(loginValue);
  };
  const handleSignIn = async (e) => {
    e.preventDefault(); // prevent page reload
    setIsLoading(true);
    setError("");
    try {
      if ((await check(loginValue)) === true) {
        await signIn(loginValue, passwordValue);
        showToast();
        navigate.push("/student");
      } else {
        toast.error("❌ Wrong Login Attempt!!", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (e) {
      setError(e.message);
    }
    setIsLoading(false);
  };

  const date = new Date();
  const currentTime = date.getHours();

  let greeting;

  if (currentTime < 12) {
    greeting = "Good Morning";
  } else if (currentTime < 18) {
    greeting = "Good Afternoon";
  } else {
    greeting = "Good Evening";
  }

  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  // window.onload = function Testimonials() {
  //   setTimeout(function () {
  //     document.getElementById("testimonial").click();
  //   }, 3000);
  // };

  return (
    <>
      {/* <AutoRotatingCarouselModal
        handleOpen={handleOpen}
        setHandleOpen={setHandleOpen}
      /> */}
      <Grid
        onContextMenu={(e) => e.preventDefault()}
        container
        className={classes.container}
      >
        <div className={classes.logotypeContainer}>
          <img src={ABlogo} alt="logo" className={classes.logotypeImage} />
          <Typography className={classes.logotypeText}>AB Physics</Typography>
        </div>
        <div className={classes.formContainer}>
          <div className={classes.form}>
            <Tabs
              value={activeTabId}
              onChange={(e, id) => setActiveTabId(id)}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              <Tab label="Login" classes={{ root: classes.tab }} />
              <Tab label="New User" classes={{ root: classes.tab }} />
            </Tabs>
            {activeTabId === 0 && (
              <React.Fragment>
                <Typography variant="h1" className={classes.greeting}>
                  {greeting}, Student
                </Typography>
                <Button
                  id="testimonial"
                  size="large"
                  className={classes.googleButton}
                  onClick={testimonials}
                >
                  <img src={ABlogo} alt="logo" className={classes.ABIcon} />
                  &nbsp;<h3>Testimonials</h3>
                </Button>
                <div>
                  <Typography
                    variant="subtitle2"
                    style={{ textAlign: "center", marginTop: "1em" }}
                  >
                    {
                      "A Tuition For Physics Is Common In Bengal, But Scientific Mentoring Is The New Key To Bring Out The Best In You"
                    }
                  </Typography>
                </div>
                <Fade in={error}>
                  <Typography
                    color="secondary"
                    className={classes.errorMessage}
                  >
                    Something is wrong with your login or password :(
                  </Typography>
                </Fade>
                <form onSubmit={handleSignIn}>
                  <TextField
                    id="email"
                    InputProps={{
                      classes: {
                        underline: classes.textFieldUnderline,
                        input: classes.textField,
                      },
                    }}
                    value={loginValue}
                    onChange={(e) => setLoginValue(e.target.value)}
                    margin="normal"
                    placeholder="Email Adress"
                    type="email"
                    fullWidth
                    autoComplete="username"
                  />
                  <TextField
                    id="password"
                    InputProps={{
                      classes: {
                        underline: classes.textFieldUnderline,
                        input: classes.textField,
                      },
                    }}
                    value={passwordValue}
                    onChange={(e) => setPasswordValue(e.target.value)}
                    margin="normal"
                    placeholder="Password"
                    type="password"
                    fullWidth
                    autoComplete="current-password"
                  />
                  <div className={classes.formButtons}>
                    {isLoading ? (
                      <CircularProgress
                        size={26}
                        className={classes.loginLoader}
                      />
                    ) : (
                      <Button
                        disabled={
                          loginValue.length === 0 || passwordValue.length === 0
                        }
                        type="submit"
                        variant="contained"
                        color="primary"
                        size="large"
                      >
                        Login
                      </Button>
                    )}
                    <Button
                      color="primary"
                      size="large"
                      className={classes.forgetButton}
                      onClick={redirectToAdmin}
                    >
                      ADMIN LOGIN
                    </Button>
                  </div>
                </form>
              </React.Fragment>
            )}
            {activeTabId === 1 && (
              <React.Fragment>
                <StudentRegister/>
                {/* <Typography variant="h1" className={classes.greeting}>
                  Oops{" "}
                  sdfd
                  <ErrorOutlineIcon
                    style={{ fontSize: "2rem", color: "red" }}
                  />
                </Typography>
                <br />
                <br />
                <Typography variant="h5" className={classes.greeting}>
                  New to ABPhysics?? Please Contact Here:
                  <hr />
                  Phone: +919051145172
                  <br />
                  <br />
                  <br />
                  <br /> EmailID: abphysics.2020@gmail.com
                </Typography>
                <br />
                <br /> */}
                
                {/* <Typography variant="h5" className={classes.greeting}> */}
                {/* Looks Like this part is still under development
                  <br />
                  Please try again later or contact Admin. */}
                {/* <br />
                <br />
                <br />
                <br />
                <br />
                <br /> */}
                {/* </Typography> */}
                {/* <Typography variant="h4" className={classes.greeting}>
                  <i>Thank You for your visit.</i>
                </Typography> */}
                {/* <Typography variant="h1" className={classes.greeting}>
                Welcome! Student
              </Typography>
              <Typography variant="h2" className={classes.subGreeting}>
                Create your account
              </Typography>
              <Fade in={error}>
                <Typography color="secondary" className={classes.errorMessage}>
                  Something is wrong with your login or password :(
                </Typography>
              </Fade>
              <TextField
                id="name"
                InputProps={{
                  classes: {
                    underline: classes.textFieldUnderline,
                    input: classes.textField,
                  },
                }}
                value={nameValue}
                onChange={(e) => setNameValue(e.target.value)}
                margin="normal"
                placeholder="Full Name"
                type="text"
                fullWidth
              />
              <TextField
                id="email"
                InputProps={{
                  classes: {
                    underline: classes.textFieldUnderline,
                    input: classes.textField,
                  },
                }}
                value={loginValue}
                onChange={(e) => setLoginValue(e.target.value)}
                margin="normal"
                placeholder="Email Adress"
                type="email"
                fullWidth
              />
              <TextField
                id="password"
                InputProps={{
                  classes: {
                    underline: classes.textFieldUnderline,
                    input: classes.textField,
                  },
                }}
                value={passwordValue}
                onChange={(e) => setPasswordValue(e.target.value)}
                margin="normal"
                placeholder="Password"
                type="password"
                fullWidth
              />
              <div className={classes.creatingButtonContainer}>
                {isLoading ? (
                  <CircularProgress size={26} />
                ) : (
                  <Button
                    onClick={() =>
                      loginUser(
                        userDispatch,
                        loginValue,
                        passwordValue,
                        props.history,
                        setIsLoading,
                        setError
                      )
                    }
                    disabled={
                      loginValue.length === 0 ||
                      passwordValue.length === 0 ||
                      nameValue.length === 0
                    }
                    size="large"
                    variant="contained"
                    color="primary"
                    fullWidth
                    className={classes.createAccountButton}
                  >
                    Create your account
                  </Button>
                )}
              </div>
              <div className={classes.formDividerContainer}>
                <div className={classes.formDivider} />
                <Typography className={classes.formDividerWord}>or</Typography>
                <div className={classes.formDivider} />
              </div>
              <Button
                size="large"
                className={classnames(
                  classes.googleButton,
                  classes.googleButtonCreating
                )}
              >
                <img src={google} alt="google" className={classes.googleIcon} />
                &nbsp;Sign in with Google
              </Button> */}
              </React.Fragment>
            )}
          </div>
          <Typography color="primary" className={classes.copyright}>
            © {new Date().getFullYear()}{" "}
            <a
              style={{ textDecoration: "none", color: "inherit" }}
              href="abphysics.in"
              rel="noopener noreferrer"
              target="_blank"
            >
              AB Physics,{" "}
            </a>
            All rights reserved.
          </Typography>
        </div>
      </Grid>
    </>
  );
}

export default withRouter(StudentLogin);
